import { combineReducers } from 'redux';
import { JobCardReducer, jobCardLogsReducer } from './job-card-reducer';

const jobCardRootReducer = combineReducers({
  jobCardData: JobCardReducer,
  jobCardLogs: jobCardLogsReducer,
});

export default jobCardRootReducer;
